import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import WaveBand from '../components/WaveBand';
import { festivalFeatures, nextFestival, venue, site } from '../data/site';

const Festival: React.FC = () => (
  <>
    <section className="section">
      <Container>
        <div className="text-center">
          <h1 className="section-title">The Festival</h1>
          <hr className="section-rule" />
          <p className="lede mx-auto">
            A free, one-day arts festival on the shore of {venue.name} in Pleasant Hill, Iowa, with
            local artists, live music, food vendors, and hands-on crafts for kids.
          </p>
        </div>
      </Container>
    </section>

    <section className="section bg-water-soft">
      <Container>
        <div className="notice bg-white mx-auto" style={{ maxWidth: '46rem' }}>
          <h2 className="section-title h4 mb-2">{nextFestival.heading}</h2>
          <p className="mb-0">
            {nextFestival.body} In the meantime, the{' '}
            <Link to="/gallery">photo gallery</Link> is the best record of what the festival has
            been.
          </p>
        </div>
      </Container>
    </section>

    <section className="section">
      <Container>
        <div className="text-center mb-4">
          <h2 className="section-title">What the day looks like</h2>
          <hr className="section-rule" />
        </div>

        <Row className="g-4 justify-content-center">
          {festivalFeatures.map((feature) => (
            <Col md={6} lg={4} key={feature.title}>
              <div className="h-100 border p-4">
                <h3 className="h4 text-logo-blue mb-3">{feature.title}</h3>
                <p className="mb-0">{feature.body}</p>
              </div>
            </Col>
          ))}
        </Row>

        <div className="text-center mt-4">
          <Link to="/sponsors" className="btn btn-secondary px-4">
            See who makes it possible
          </Link>
        </div>
      </Container>
    </section>

    <WaveBand />

    <section className="section bg-navy text-white">
      <Container>
        <Row className="justify-content-center text-center">
          <Col lg={7}>
            <h2 className="section-title text-white">Where it happens</h2>
            <hr className="section-rule" />
            <p className="mb-1 fs-5">{venue.name}</p>
            <p className="mb-4">{venue.address}</p>
            <a
              className="btn btn-primary px-4"
              href={venue.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open in Maps
            </a>
            <p className="mt-4 mb-0">
              Questions about the festival? Email{' '}
              <a href={`mailto:${site.email}`} className="text-water">{site.email}</a>.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  </>
);

export default Festival;
